import { LocaleData } from '@/translations/LocaleData';
import * as Yup from 'yup';

export interface ResultForm {
    title: string;
    introduction?: string;
    image?: string;
    description: string;
    hint?: string;
}

export const resultSchema: Yup.ObjectSchema<ResultForm> = Yup.object().shape<ResultForm>({
    title: Yup.string().when(['$existingTitles', '$strings'], (existingTitles: string[], strings: LocaleData) =>
        Yup.string()
            .test(
                'notSameTitle',
                strings.SAME_TITLE_IN_ANOTHER_RESULT,
                (value: string) => !existingTitles.some((title: string) => title.toUpperCase() === value.toUpperCase()),
            )
            .trim()
            .required(),
    ),
    introduction: Yup.string().notRequired(),
    image: Yup.string().notRequired(),
    description: Yup.string()
        .trim()
        .required(),
    hint: Yup.string().when(['$hintRequired'], (hintRequired: boolean) =>
        hintRequired
            ? Yup.string()
                  .trim()
                  .required()
            : Yup.string().notRequired(),
    ),
});

export const formInitialState = {
    title: '',
    introduction: '',
    image: '',
    description: '',
    hint: '',
};

export const formErrors: { titleError: string | undefined } = {
    titleError: undefined,
};
